import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../lib/cn';

/**
 * Select — Wrapper sobre <select> nativo, con prefix opcional.
 *
 * Uso:
 *   <Select value={x} onChange={setX}>
 *     <option value="a">Opción A</option>
 *   </Select>
 *
 *   <Select prefix={<Building className="size-3.5" />}>
 *     <option>Todas las unidades</option>
 *   </Select>
 */
export const Select = React.forwardRef(({
    prefix,
    className,
    children,
    ...props
}, ref) => (
    <div className={cn(
        'relative flex items-center h-9 w-full',
        'rounded-lg border border-[hsl(var(--input))] bg-white',
        'transition-colors',
        'focus-within:border-[hsl(var(--brand-light))] focus-within:ring-2 focus-within:ring-[hsl(var(--ring))]',
        className
    )}>
        {prefix && (
            <span className="absolute left-3 text-slate-400 pointer-events-none flex items-center">
                {prefix}
            </span>
        )}
        <select
            ref={ref}
            className={cn(
                'appearance-none w-full h-full bg-transparent outline-none',
                'text-sm text-slate-900 cursor-pointer',
                'pr-8',
                prefix ? 'pl-9' : 'pl-3'
            )}
            {...props}
        >
            {children}
        </select>
        <ChevronDown className="absolute right-2.5 size-3.5 text-slate-400 pointer-events-none" />
    </div>
));

Select.displayName = 'Select';
